import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { OnTapBasicService } from 'app/services/dal/on-tap-basic.service';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as TapActions from './actions'
import { shouldLoadData, trackLoading } from '../effect-helpers';
import * as fromOnTapBasic from './reducer';



@Injectable()
export class OnTapBasicEffects {

  constructor(
    private actions$: Actions,
    private store: Store,
    private onTapService: OnTapBasicService) { }

  getKegs$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(TapActions.loadItems),
        shouldLoadData(
          this.store,
          'onTapBasic',
          (action) => action.barId,
          fromOnTapBasic.selectAllItems
        ),
        switchMap((action) =>
          trackLoading(
            this.store,
            'onTapBasic',
            action.barId,
            this.onTapService.getItems(action.barId).pipe(
              map(items => TapActions.loadItemsSuccess({ items: items })),
              catchError(error => of(TapActions.loadItemsFailure({ error })))
            )
          )
        )
      );
  });


}
